import { render, staticRenderFns } from "./BaseButtonSubmit.vue?vue&type=template&id=5b3d2f8d&"
import script from "./BaseButtonSubmit.vue?vue&type=script&lang=js&"
export * from "./BaseButtonSubmit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports